var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeroTemporario'),_c('Segmentos'),_c('Vagas'),_c('Razoes'),_c('Sobre')],1)}
var staticRenderFns = []

export { render, staticRenderFns }